import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-shield-user-icon',
  templateUrl: './communication-shield-user.component.html'
})
export class CommunicationShieldUserComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
